import Box from '@mui/material/Box'
import {
  accountTabBarSx,
  accountTabButtonActiveSx,
  accountTabButtonBaseSx,
} from '@/features/account/lib/account-settings-tokens'

export type AccountTab = 'details' | 'password'

interface Props {
  readonly activeTab: AccountTab
  readonly onTabChange: (tab: AccountTab) => void
}

export function AccountTabBar({ activeTab, onTabChange }: Props) {
  return (
    <Box sx={accountTabBarSx} role="tablist" aria-label="Account tabs" data-testid="account-tabs">
      <Box
        component="button"
        type="button"
        role="tab"
        aria-selected={activeTab === 'details'}
        id="account-tab-details"
        data-testid="account-tab-details"
        onClick={() => onTabChange('details')}
        sx={activeTab === 'details' ? accountTabButtonActiveSx : accountTabButtonBaseSx}
      >
        Account Details
      </Box>
      <Box
        component="button"
        type="button"
        role="tab"
        aria-selected={activeTab === 'password'}
        id="account-tab-password"
        data-testid="account-tab-password"
        onClick={() => onTabChange('password')}
        sx={activeTab === 'password' ? accountTabButtonActiveSx : accountTabButtonBaseSx}
      >
        Change Password
      </Box>
    </Box>
  )
}
